var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEyeCrossed(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Eye",
    opacity: 0.54
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4929",
    "data-name": "Group 4929",
    transform: "translate(-695 -387)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_13",
    "data-name": "Union 13",
    d: "M-5988.647,149.323a.5.5,0,0,1,0-.707l2.725-2.725c-2.777-1.65-4.078-4.16-4.078-5.172,0-1.565,3.118-6.721,10-6.721a11.707,11.707,0,0,1,4.937,1.033l2.679-2.679a.5.5,0,0,1,.707,0,.5.5,0,0,1,0,.708l-2.456,2.456c2.814,1.65,4.132,4.186,4.132,5.2,0,1.566-3.117,6.723-10,6.723a11.694,11.694,0,0,1-5-1.061l-2.942,2.942a.5.5,0,0,1-.354.147A.5.5,0,0,1-5988.647,149.323Zm8.648-2.865c6.219,0,9.015-4.559,9.015-5.738,0-.779-1.228-3.045-3.867-4.485l-1.939,1.94a4.077,4.077,0,0,1,.889,2.547,4.1,4.1,0,0,1-4.1,4.1,4.078,4.078,0,0,1-2.546-.889l-1.707,1.707A10.893,10.893,0,0,0-5980,146.458Zm-9.017-5.738c0,.775,1.21,3.014,3.81,4.455l1.958-1.958a4.078,4.078,0,0,1-.85-2.5,4.1,4.1,0,0,1,4.1-4.1,4.082,4.082,0,0,1,2.5.849l1.695-1.695a10.912,10.912,0,0,0-4.19-.795C-5986.22,134.984-5989.016,139.545-5989.016,140.72Zm9.015,3.115a3.118,3.118,0,0,0,3.116-3.113,3.1,3.1,0,0,0-.607-1.846l-4.353,4.353A3.1,3.1,0,0,0-5980,143.835Zm-3.115-3.113a3.094,3.094,0,0,0,.57,1.793l4.339-4.339a3.1,3.1,0,0,0-1.794-.569A3.118,3.118,0,0,0-5983.115,140.722Z",
    transform: "translate(6685 256)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1645",
    "data-name": "Rectangle 1645",
    width: 20,
    height: 20,
    transform: "translate(695 387)",
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeCrossed);
export default __webpack_public_path__ + "static/media/Eye-crossed.8e2e11c4bbff7ab5c3270afc0b6b3f50.svg";
export { ForwardRef as ReactComponent };